import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { portalUrl } from "@/lib/host-mode";

/**
 * Wrap the public homepage so that a logged-in staff/doctor/admin who
 * lands on "/" (bookmark, typed URL, post-logout-of-another-tab redirect)
 * is auto-routed to their respective portal. Patients and anonymous
 * visitors continue to see the marketing landing page.
 *
 * Honours a session flag `skipPortalRedirect` so that, after using the
 * "Back to website" link in Header, the user can browse the public
 * marketing site without being instantly bounced back.
 */
const ROLE_PORTAL = {
    admin: "/admin",
    doctor: "/doctor",
    clinic_staff: "/doctor",
    staff: "/coe",
    sales: "/sales",
    sales_manager: "/sales",
};

export default function PortalRedirect({ children }) {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (loading || !user) return;
        const skip = sessionStorage.getItem("skipPortalRedirect") === "1";
        if (skip) return;
        const dest = ROLE_PORTAL[user.role];
        if (!dest) return;
        // In split-host mode the destination lives on `my.invisique.in` so
        // we do a full-page hop. In universal mode (preview / local) the
        // SPA owns both surfaces so React Router handles it.
        const resolved = portalUrl(dest);
        if (resolved.startsWith("http")) {
            window.location.assign(resolved);
        } else {
            navigate(resolved, { replace: true });
        }
    }, [user, loading, navigate]);

    return children;
}
